module.exports = __webpack_public_path__ + "static/img/tagsBg.7d861fdf.png";